import React, { forwardRef, useContext } from "react";

import FormContext from "./FormContext";
import { getHelperText, getValue } from "./helpers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
    TimePicker,
    TimePickerProps,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { FormControl, FormHelperText } from "@mui/material";
import updateLocale from "dayjs/plugin/updateLocale";

export interface IGPTimePicker extends Omit<TimePickerProps<any>, "onChange"> {
    errorText?: string;
    id: string;
    onChange?: Function;
    regex?: string;
    helperText?: string;
    fullWidth?: boolean;
    format?: string;
}

const GPTimePicker = forwardRef<any, IGPTimePicker>((props, ref) => {
    const {
        errorText = "",
        format = "HH:mm",
        fullWidth,
        helperText = "",
        id,
        onChange,
        sx,
        value,
        ...restProps
    } = props;
    const lang = document.documentElement.lang;
    const context = useContext(FormContext);
   
    dayjs.extend(updateLocale);
    dayjs.updateLocale(lang, {
        weekStart: 1,
    });

    const onChangeValue = (value: any) => {
        const formattedValue = value ? dayjs(value).format(format) : null;
        if (!!onChange) {
            onChange({ id, value: formattedValue }, context);
        } else {
            context?.onChange({ id, value: formattedValue });
        }
    };

    const { inputHelperText, isError } = getHelperText(
        id,
        context,
        errorText,
        helperText
    );

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang}>
            <FormControl fullWidth={fullWidth} sx={sx} error={isError}>
                <TimePicker
                    {...restProps}
                    sx={{
                        height: 40,
                        width: "100%",

                        pr: 0,
                        ".MuiInputBase-root": {
                            height: 40,
                            width: "100%",
                            // fontSize: 13,
                        },
                        ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: isError ? "#d32f2f" : "#36845B",
                            },
                        ".MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: isError
                                    ? "#d32f2f"
                                    : "rgba(0, 0, 0, 0.23)",
                            },
                        ".MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: isError
                                    ? "#d32f2f"
                                    : "rgba(0, 0, 0, 0.87)",
                            },
                        ".MuiFormLabel-root, .MuiFormLabel-root.Mui-focused": {
                            color: isError ? "#d32f2f" : "#36845B",
                        },
                        ".MuiFormLabel-root:not(.Mui-focused)": {
                            color: isError ? "#d32f2f" : "rgba(0, 0, 0, 0.6)",
                        },
                    }}
                    value={
                        getValue(id, context, value)
                            ? dayjs(getValue(id, context, value), format)
                            : null
                    }
                    onChange={onChangeValue}
                    inputRef={ref}
                    format={format}
                    ampm={false}
                />
                {inputHelperText.length > 0 && (
                    <FormHelperText>{inputHelperText}</FormHelperText>
                )}
            </FormControl>
        </LocalizationProvider>
    );
});

export default GPTimePicker;
